import styles from './CertifiedBadge.module.css';
import {cn} from '@/lib/utils';
export interface CertifiedBadgeProps {
  className?: string;
  label?: string;
}
export const CertifiedBadge = ({className, label}: CertifiedBadgeProps) => {
  return (
    <div className={cn(className, styles.container)}>
      <div className={cn(styles.content)}>
        <div className={styles.label}>{label}</div>
      </div>
    </div>
  );
};
